import React from "react";

export default function PillTabs({ tabs = [], activeTab, onTabChange, className = "" }) {
  return (
    <div
      className={`
        flex items-center overflow-x-auto scrollbar-hide
        space-x-2 px-2 py-1 mb-6 bg-gray-200 rounded-full
         sm:w-[60%] md:w-[50%] lg:w-[30%] mx-3
        ${className}
      `}
    >
      {tabs.map(tab => (
        <button
          key={tab}
          onClick={() => onTabChange && onTabChange(tab)}
          className={`
            px-4 py-1 rounded-full text-sm font-medium transition whitespace-nowrap
            ${tab === activeTab ? "bg-white text-gray-900" : "text-gray-500"}
          `}
        >
          {tab}
        </button>
      ))}
    </div>
  );
}
